<template>
  <custom-dialog width="1338px" :title="model.title" class="protocol-construct-setting-dialog" :visible="visible" v-on="$listeners" :fullscreen="true" :append-to-body="true">
    <div class="dialog-body" ref="body" :style="{ height: clientHeight + 'px' }">
      <div class="ub">
        <div class="ub-f1">
          <h1 class="title">{{ $t('dms_construct_setting_dialog.xie_yi_bu_jian') }}</h1>
          <div class="box">
            <div class="search-hd">
              <el-input v-model="formSearch.componentName" clearable :placeholder="$t('dms_construct_setting_dialog.bjmcbjbh')" style="width: 380px; float: left" @input="componentNameChangeHandler"></el-input>
              <custom-select
                ref="componentGroupSel"
                v-if="formSearch.protocolCode"
                v-model="formSearch.parentCode"
                :props="{ label: 'componentName', value: 'componentCode' }"
                :fullUrl="componentListTypeUrl"
                style="float: right; width: 130px"
                :placeholder="$t('dms_construct_setting_dialog.bu_jian_fen_zu')"
                @change="onPageChange({ page: 1 })"
              ></custom-select>
            </div>
            <div style="width: 580px; flex: 1">
              <custom-table
                v-model="deviceIn"
                :column="tableColumn"
                :data="deviceList"
                height="100%"
                type="checkbox"
                ref="tb1"
                @filter="filterChange"
                @sort="sortChange"
                selectableKey="disabled"
              ></custom-table>
            </div>
            <div class="table-page">
              <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
            </div>
          </div>
        </div>
        <div class="ubv ub-ac ub-xc" style="padding: 0 16px">
          <div class="btn" @click="addDevice">
            <i class="el-icon-arrow-right"></i>
          </div>
          <div class="btn2" @click="removeDevice">
            <i class="el-icon-arrow-left"></i>
          </div>
        </div>
        <div class="ub-f1 selected-device">
          <h1 class="title">{{ $t('dms_construct_setting_dialog.yi_xuan_bu_jian') }}</h1>
          <div class="box">
            <div class="search-hd">
              <el-input clearable :placeholder="$t('dms_construct_setting_dialog.bjfzbjmcbjbh')" v-model="formSearch.keyword" style="width: 580px"></el-input>
            </div>
            <div style="width: 580px; flex: 1">
              <custom-table v-model="deviceOut" :data="selectedData" :column="tableColumn" height="100%" ref="tb2" type="checkbox" @filter="filterChange" @sort="sortChange"></custom-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="save">{{ $t('dms_construct_setting_dialog.que_ren') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
// 结构设置
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  props: {
    protocolCode: String,
    protocolClass: String,
  },
  data() {
    return {
      tableCode: 'product_import_device',

      deviceList: [],
      formSearch: {
        pageSize: 50,
        pageNum: 1,
        protocolCode: '',
        componentName: '',
        keyword: '',
        parentCode: '',
      },
      totalRows: 0,
      selectedDevice: [],
      deviceIn: [],
      deviceOut: [],
      componentNameChangeHandler: null,
      clientHeight: document.body.clientHeight - 100,
    };
  },
  computed: {
    selectedData() {
      const ret = this.fuzzyQuery(this.selectedDevice, ['parentComponentName', 'componentName', 'componentCode'], this.formSearch.keyword);

      // 分组排序
      // ret.sort((a, b) => {
      //   const res = Number(a.parentId.slice(5)) - Number(b.parentId.slice(5));
      //   return res;
      // });
      return ret;
    },
    // 部件分组请求接口的地址
    componentListTypeUrl() {
      if (this.formSearch.protocolCode) {
        const url = `${apis.ComponentListType}/${this.formSearch.protocolCode}`;
        return url;
      }
      return '';
    },
  },
  mounted() {
    window.addEventListener('resize', this.onResize, false);
    this.getTableColumn();
    this.init();
    this.componentNameChangeHandler = this.$debounce(() => {
      this.onPageChange({ page: 1 });
    }, 300);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize, false);
  },
  methods: {
    onResize() {
      this.clientHeight = document.body.clientHeight - 100;
    },
    protocolCodeChange() {
      this.onPageChange({ page: 1 });
      // 部件分组下拉框的props参数有时延
      setTimeout(() => {
        this.formSearch.parentCode = '';
        this.$refs.componentGroupSel.getSelectList();
      }, 100);
    },
    fixBody() {
      setTimeout(() => {
        this.$refs.body.scrollTop = 0;
      }, 100);
    },
    closeDialog() {
      this.visible = false;
    },
    // async getDeviceType() {
    //   const res = await this.$getJSON(apis.ComponentCopyListProtocol, {
    //     // protocolCode: this.protocolCode
    //   });
    //   this.deviceType = res.data.filter(item => item.protocolCode !== this.protocolCode);
    //   this.formSearch.protocolCode = this.deviceType[0].protocolCode;
    // },
    getDeviceList() {
      this.$getJSON(apis.DerivedComponentFromStandardPageComponent, {
        ...this.formSearch,
      }).then((res) => {
        this.deviceList = res.data.records;
        this.totalRows = res.data.total;
        this.formatDeviceList();
        return this.deviceList;
      });
    },
    init() {
      // 衍生协议中的protocolClass就是标准协议的protocolCode，因为分组调用的是标准协议的，所以 要取protocolClass
      this.formSearch.protocolCode = this.protocolClass;
      this.getDeviceList();
      this.fixBody();
    },
    formatDeviceList() {
      const list = this.deviceList;
      const selectedData = this.selectedDevice;
      list.forEach((item) => {
        if (selectedData.some(obj => obj.componentId === item.componentId)) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
      });
    },
    addDevice() {
      this.deviceIn.forEach((item) => {
        const has = this.selectedDevice.find(t => t.componentId === item.componentId);
        if (!has) {
          this.selectedDevice.push(item);
        }
      });
      this.$refs.tb1.$refs.tb1.clearSelection();
      this.formatDeviceList();
    },
    removeDevice() {
      this.deviceOut.forEach((item) => {
        this.selectedDevice = this.selectedDevice.filter(t => t.componentId !== item.componentId);
      });

      // 直接formatDeviceList，table不更新禁用状态
      const copyList = [...this.deviceList];
      this.deviceList = [];
      setTimeout(() => {
        this.deviceList = copyList;
        this.formatDeviceList();
      }, 0);
    },
    getSaveReqData() {
      return this.selectedDevice.map(item => item.componentCode);
    },
    save() {
      if (!this.selectedDevice || !this.selectedDevice.length) {
        const msg = this.$t('dms_construct_setting_dialog.qgxbj');
        this.$message.error(msg);
      } else {
        const reqData = this.getSaveReqData();
        this.$postJSON(`${apis.DerivedComponentRelationSave}/${this.protocolCode}`, reqData).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.$emit('success');
          this.closeDialog();
        });
      }
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getDeviceList();
    },
  },
};
</script>

<style lang="scss">
.protocol-construct-setting-dialog {
  .el-dialog.is-fullscreen {
    width: 1338px;
  }

  .el-input-group__prepend {
    font-size: 0;
    border-radius: 2px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .dialog-body {
    overflow: hidden;
    display: flex;
    // height: 700px;

    .ub {
      flex: 1;
    }
  }
  .box {
    margin-top: 16px;
    padding: 0 16px 5px 16px;
    border: 1px solid #dee2e6;
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    // height: calc(100% - 40px);
  }

  .ub-f1 {
    width: 380px;
    display: flex;
    flex-direction: column;
  }
  .title {
    color: #35405b;
    font-weight: bold;
    font-size: 14px;
  }
  .btn {
    cursor: pointer;
    width: 24px;
    height: 24px;
    line-height: 22px;
    border-radius: 4px;
    background-color: #00afff;
    border: 1px solid rgba(24, 144, 255, 1);
    text-align: center;
    color: #ffffff;
  }
  .btn2 {
    cursor: pointer;
    border-radius: 4px;
    width: 24px;
    height: 24px;
    line-height: 22px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    text-align: center;
    color: #000000;
    margin-top: 10px;
  }

  .el-dialog__footer {
    padding-top: 10px;
    padding-bottom: 10px;
    border-top: 1px solid #e9ebec;
  }

  // .selected-device {
  //   padding-top: 80px;
  // }
}
</style>
